import React from 'react';
import {
    Card,
    Details,
    DetailsStringValue,
    DetailsReactNodeValue,
    DetailsArrayValue,
    SimpleTable,
    SimpleTableHeader,
    ExamStatus,
    renderRow,
    SignedExpert,
} from 'components';
import { ExamInfoTabProps } from '../ExamInfoTab';
import styles from './SovietProtocolTab.module.scss';

const SovietProtocolTab = ({ examDetails }: IProps) => {
    const showQuorum = React.useMemo(() => examDetails.status !== ExamStatus.AkProtocolSigned, [examDetails]);
    const chairman = React.useMemo(() => examDetails.sovietExperts.find(expert => expert.chairman), [examDetails]);

    const getInfoRowsFromExamDetails = () => {
        const infoRows: (DetailsReactNodeValue | DetailsStringValue | DetailsArrayValue)[] = [
            new DetailsStringValue('Номер протокола', examDetails.protocolNumber ? examDetails.protocolNumber.toString() : ''),
            new DetailsStringValue('Город', examDetails.city),
            new DetailsStringValue('Дата заседания', examDetails.date.format('DD.MM.YYYY')),
        ];

        return infoRows;
    };

    const renderSignatures = () => (
        <div className="mb-5">
            <span className="d-block">Утвердить результаты профессиональных экзаменов в рамках Правил проведения центром
            оценки квалификаций независимой оценки квалификации в форме профессионального
            экзамена, установленных в соответствии с Постановлением Правительства Российской
            Федерации от 16.11.2016 г. № 1204.
            Признать результаты независимой оценки квалификации в форме профессионального
            экзамена.
            </span>
            <span className="d-block">Профессиональный экзамен:</span>
            <span className="d-block">{`«${examDetails.qualificationTitle} (${examDetails.qualificationLevel} уровень квалификации)»`}</span>
            <span className="d-block">{`Дата проведения экзамена: ${examDetails.date.format('DD.MM.YYYY')}`}</span>
            <span className="d-block">{`Время проведения экзамена: ${examDetails.date.format('HH:MM')} МСК`}</span>
            <span className="d-block">{`Место проведения экзамена: ${examDetails.examinationCenterName}, ${examDetails.city}, ${examDetails.address}`}</span>
            <span className="d-block">{`Протокол Аттестационной комиссии № ${examDetails.protocolNumber} прилагается`}</span>
        </div>
    );

    const getBottomInfoRowsFromExamDetails = () => {
        let infoRows: (DetailsReactNodeValue | DetailsStringValue | DetailsArrayValue)[] = [];

        if (showQuorum) {
            infoRows.push(new DetailsReactNodeValue('Кворум',
                <span>
                    Всего членов Совета по профессиональным квалификациям финансового рынка: {examDetails.sovietExperts.length} <br />
                    Участвовало: {examDetails.sovietExperts.filter(e => e.active && e.signed).length} <br />
                    Кворум имеется. Заседание правомочно принимать решения по всем вопросам повестки дня.
                </span>));
        }

        infoRows.push(new DetailsStringValue('Повестка', `Об утверждении результатов профессиональных экзаменов в рамках Правил проведения
        центром оценки квалификаций независимой оценки квалификации в форме
        профессионального экзамена, установленных в соответствии с Постановлением
        Правительства Российской Федерации от 16.11.2016 г. № 1204.`));

        const expertsRows = [
            new DetailsReactNodeValue('На голосование', renderSignatures()),
            new DetailsStringValue('За', `${examDetails.sovietExperts.filter(e => e.active && e.signed).length}`),
            new DetailsStringValue('Против', '0'),
            new DetailsStringValue('Воздержался', '0'),
            new DetailsStringValue(showQuorum ? 'Итог' : 'Статус', showQuorum ? 'В процессе подписания' : 'Идет голосование'),
        ];

        infoRows = [...infoRows, ...expertsRows];

        return infoRows;
    };

    const tableHeaders: SimpleTableHeader[] = [
        { title: '№', fieldName: 'number' },
        { title: 'ФИО ЧЛЕНА СОВЕТА', columnStyles: { minWidth: '20rem' }, fieldName: 'fullName' },
        { title: 'ДОЛЖНОСТЬ', columnStyles: { minWidth: '100%', textAlign: 'right' }, fieldName: 'position' },
        { title: 'Результат', columnStyles: { minWidth: '7rem' }, fieldName: 'result' },
    ];

    const tableRows = examDetails.sovietExperts.map(({
        expertId, fullName, position, signed,
    }, i) => ({
        id: expertId,
        columns: [
            i + 1,
            fullName,
            position || '',
            signed ? 'За' : 'Нет голоса',
        ],
    }));

    return (
        <Card
          title="Подписание решения Совета"
          category="Необходимо подписать решение Совета"
          contentClassName="pt-0"
          cardClassName="pt-0"
          withoutBorder
          withoutPadding
        >
            <div className={styles.detailsContainer}>
                <Details infoRows={getInfoRowsFromExamDetails()} withDarkRowLabel />
            </div>

            <SimpleTable
              tableHeaders={tableHeaders}
              tableRows={tableRows}
              handleRowClick={() => true}
              placeholderText=" "
            />

            <div className={styles.detailsContainer}>
                <Details infoRows={getBottomInfoRowsFromExamDetails()} withDarkRowLabel />
            </div>

            {examDetails.status === ExamStatus.SovietProtocolSignedByChairman && chairman ? (
                <div className={styles.detailsContainer}>
                    {renderRow('Подпись', <SignedExpert expert={chairman} commissionTitle="совета" />, 'mt-5')}
                </div>
            ) : null}

        </Card>
    );
};

export default SovietProtocolTab;

interface IProps {
    examDetails: ExamInfoTabProps['examDetails'];
}
